import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const STATUS_STYLE = {
  operational: { dot: 'bg-success', text: 'text-success', label: 'Operational', pulse: true },
  degraded: { dot: 'bg-warning', text: 'text-warning-text', label: 'Degraded', pulse: true },
  down: { dot: 'bg-destructive', text: 'text-destructive-text', label: 'Down', pulse: true },
  unmonitored: { dot: 'bg-input', text: 'text-muted-foreground', label: 'Not monitored', pulse: false },
};

/**
 * A single platform-health tile. `status` must be one of the keys above.
 * Use "unmonitored" (not "operational") for anything the backend doesn't
 * actually report a real signal for -- never default to a green dot for
 * data that isn't really being checked.
 */
const HealthCard = ({ icon: Icon, name, status = 'unmonitored', detail, className }) => {
  const style = STATUS_STYLE[status] || STATUS_STYLE.unmonitored;
  return (
    <Card className={cn('flex items-center gap-3 p-4 card-hover-lift', className)}>
      <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-muted">
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
        <span className="absolute -right-0.5 -top-0.5 flex h-2.5 w-2.5">
          {style.pulse && (
            <span className={cn('absolute inline-flex h-full w-full animate-ping rounded-full opacity-60', style.dot)} />
          )}
          <span className={cn('relative inline-flex h-2.5 w-2.5 rounded-full ring-2 ring-card', style.dot)} />
        </span>
      </div>
      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-foreground">{name}</p>
        <p className={cn('text-xs', style.text)}>{detail || style.label}</p>
      </div>
    </Card>
  );
};

export default HealthCard;
